import { FC } from 'external/react'
import { clsx } from 'external/clsx'

import useAuth from 'context/auth-context/hook'

const LoginButton: FC = () => {
    const {showLogin, role} = useAuth()
	return (
        <li className={clsx('nav-item', 'me-4', {'d-none': !!role})}>
            <button className='btn btn-purple' onClick={() => showLogin()}>
                Login
            </button>
        </li>
	)
}

export default LoginButton
